<template>
	<div
		v-if="countdown.remaining > 0"
		class="flex h-8 w-36 items-center justify-between rounded border border-gray-100 px-2 font-digital7 text-2xl"
	>
		<div class="w-8 text-center">
			<p class="font-bold">{{ countdown.hours.toString().padStart(2, "0") }}</p>
		</div>

		<p class="text-center">:</p>

		<div class="w-8 text-center">
			<p class="font-bold">
				{{ countdown.minutes.toString().padStart(2, "0") }}
			</p>
		</div>

		<p class="text-center">:</p>

		<div class="w-8 text-center">
			<p class="font-bold">
				{{ countdown.seconds.toString().padStart(2, "0") }}
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
// Props
const properties = defineProps<{
	activeTo: Date;
}>();

interface CountdownValues {
	hours: number;
	minutes: number;
	seconds: number;
	remaining: number;
}

const currentTimeDefault = Date.now();
const targetTimeDefault = properties.activeTo.getTime();
const timeRemainingDefault = targetTimeDefault - currentTimeDefault;

const countdown = ref<CountdownValues>({
	hours: Math.floor(
		(timeRemainingDefault % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
	),
	minutes: Math.floor((timeRemainingDefault % (1000 * 60 * 60)) / (1000 * 60)),
	seconds: Math.floor((timeRemainingDefault % (1000 * 60)) / 1000),
	remaining: timeRemainingDefault,
});

// Update countdown values
const updateCountdown = () => {
	const currentTime = Date.now();
	const targetTime = properties.activeTo.getTime();
	const timeRemaining = targetTime - currentTime;

	countdown.value.remaining = timeRemaining;

	if (timeRemaining > 0) {
		countdown.value.hours = Math.floor(timeRemaining / (1000 * 60 * 60));
		countdown.value.minutes = Math.floor(
			(timeRemaining % (1000 * 60 * 60)) / (1000 * 60),
		);
		countdown.value.seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
	} else {
		// If the activeTo date has already passed, display a message
		countdown.value.hours = 0;
		countdown.value.minutes = 0;
		countdown.value.seconds = 0;
	}
};

// Update countdown initially and watch for changes in activeTo
onMounted(() => {
	updateCountdown();

	// Update countdown every second
	const intervalId = setInterval(updateCountdown, 1000);

	// Clear the interval when the component is unmounted
	onUnmounted(() => {
		clearInterval(intervalId);
	});
});
</script>
